class ReplicaProductStripComponent extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.slider = this.querySelector('[data-replica-strip-slider]');
    this.items = Array.from(this.querySelectorAll('[data-replica-strip-item]'));
    this.controls = this.querySelector('[data-replica-strip-controls]');
    this.previousButton = this.querySelector('[data-replica-strip-previous]');
    this.nextButton = this.querySelector('[data-replica-strip-next]');
    this.status = this.querySelector('[data-replica-strip-status]');

    if (!this.slider || this.items.length === 0) return;

    this.dataset.initialized = 'true';
    this.currentIndex = 0;
    this.ticking = false;

    this.onScroll = this.onScroll.bind(this);
    this.onPrevious = this.onPrevious.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onBlockSelect = this.onBlockSelect.bind(this);
    this.update = this.update.bind(this);

    this.slider.addEventListener('scroll', this.onScroll, { passive: true });
    this.previousButton?.addEventListener('click', this.onPrevious);
    this.nextButton?.addEventListener('click', this.onNext);
    document.addEventListener('shopify:block:select', this.onBlockSelect);

    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.slider);
    this.update();
  }

  disconnectedCallback() {
    this.slider?.removeEventListener('scroll', this.onScroll);
    this.previousButton?.removeEventListener('click', this.onPrevious);
    this.nextButton?.removeEventListener('click', this.onNext);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    this.resizeObserver?.disconnect();
  }

  onScroll() {
    if (this.ticking) return;

    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  onPrevious() {
    this.scrollToIndex(this.currentIndex - 1);
  }

  onNext() {
    this.scrollToIndex(this.currentIndex + 1);
  }

  onBlockSelect(event) {
    const selectedItem = event.target.closest?.('[data-replica-strip-item]');
    if (!selectedItem || !this.contains(selectedItem)) return;

    const selectedIndex = this.items.indexOf(selectedItem);
    if (selectedIndex >= 0) this.scrollToIndex(selectedIndex, false);
  }

  scrollToIndex(index, smooth = true) {
    const safeIndex = Math.max(0, Math.min(index, this.items.length - 1));
    const target = this.items[safeIndex];
    if (!target) return;

    this.slider.scrollTo({
      left: target.offsetLeft,
      behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto',
    });
  }

  update() {
    if (!this.slider || this.items.length === 0) return;

    const scrollPosition = this.slider.scrollLeft;
    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;

    this.items.forEach((item, index) => {
      const distance = Math.abs(item.offsetLeft - scrollPosition);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    this.currentIndex = nearestIndex;

    if (this.previousButton) this.previousButton.disabled = nearestIndex === 0;
    if (this.nextButton) this.nextButton.disabled = nearestIndex === this.items.length - 1;
    if (this.status) this.status.textContent = `${nearestIndex + 1} / ${this.items.length}`;

    if (this.controls) {
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const hasOverflow = this.slider.scrollWidth > this.slider.clientWidth + 1;
      this.controls.hidden = desktop || !hasOverflow || this.items.length < 2;
    }
  }
}

if (!customElements.get('replica-product-strip-component')) {
  customElements.define('replica-product-strip-component', ReplicaProductStripComponent);
}
